'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var StepControlTypeEntityService = function StepControlTypeEntityService(configurationService, restangular, App, ScheduleChangeConstants, $log) {
  var MARKET_TYPE = ScheduleChangeConstants.TYPE.MARKETS;
  var FLIGHT_TYPE = ScheduleChangeConstants.TYPE.FLIGHTS;
  function getMarketEntities() {
    return _.chain(configurationService.getEntities()).filter(MARKET_TYPE).sortBy('description').map('description').value();
  }
  function getFlightEntities() {
    return _.chain(configurationService.getEntities()).filter(FLIGHT_TYPE).sortBy('description').map('description').value();
  }
  function requestEntities() {
    return restangular.one('staticdata').one('entity').get();
  }
  function pushNew(description, type, data) {
    var id = _.max(_.map(data.entities, 'id')) + 1;
    data.entities.push(_.extend({
      description: description,
      id: id
    }, type));
    var newData = {
      entities: _.cloneDeep(data.entities),
      id: data.id
    };
    newData.entities = _.drop(newData.entities, newData.entities.length - 1);
    return newData;
  }
  function saveNewList(data) {
    return restangular.one('staticdata').one('entity').patch(data).then(function () {
      return data;
    });
  }
  function updateConfig(data) {
    App.entities = data.entities;
  }
  function showError(message) {
    $log.error('StepControlTypeEntityService: showError - ' + message);
    toastr.error(message);
  }
  function saveMarketEntity(description, type) {
    requestEntities().then(pushNew.bind(null, description, type)).then(saveNewList).then(updateConfig)["catch"](showError.bind(null, 'Couldn\'t save'));
  }
  return {
    getMarketEntities: getMarketEntities,
    getFlightEntities: getFlightEntities,
    saveMarketEntity: saveMarketEntity
  };
};
StepControlTypeEntityService.$inject = ['ConfigurationService', 'Restangular', 'App', 'ScheduleChangeConstants', '$log'];
module.exports = StepControlTypeEntityService;